import MenuLinks from "./MenuLinks";
import classnames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
const Menu = props => {
  const classes = classnames('hc-c-menu', {
    'hc-c-menu--open': props.open
  });
  return /*#__PURE__*/_jsxs("div", {
    id: "hc-c-menu",
    hidden: !props.open,
    className: classes,
    children: [props.submenuTop, props.beforeLinks, props.links && /*#__PURE__*/_jsx(MenuLinks, {
      links: props.links
    }), props.submenuBottom]
  });
};
export default Menu;